import React      from 'react';
import { Field }  from 'redux-form';
import classNames from 'classnames';

import TextAreaField from './base/TextAreaField';

export const RenderTextArea = ({ ...props }) => (
  <Field
    component={FieldWrapper}
    {...props}
  />
);

const FieldWrapper = (props) => {
  const {
          input,
          label,
          meta: {
                  touched,
                  error,
                },
        } = props;

  return (
    <div className={classNames('field textArea', { 'empty': input.value === '' })}>
      <TextAreaField {...props} />
      <label>{label}</label>
      {touched && error && (<span className="error">{error}</span>)}
    </div>
  );
};